import { TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import SimuladorNumericInput from "./SimuladorNumericInput";


export const SimuladorIncentivoORBasico = ({ porc_Incentivo = 0, setTotal = null }) => {

    const [state, setState] = useState({
        meta: 0,
        real: 0,
        cumplimiento: 0,
        porcentaje: 0,
        incentivo: 0,
    });
    const handleChange = ({ target }) => {
        setState({
            ...state,
            [target.name]: target.value,
        });
    };

    
    useEffect(() => {
        if (Number(state.real) !== 0) {
            let incentivo = 0;

            if (porc_Incentivo !== null) {
                incentivo = Number(state.real) * porc_Incentivo;

                const newState = {
                    ...state,
                    incentivo,
                };

                setState(newState);
                if (setTotal) setTotal(incentivo);
            } else {
                const resetState = {
                    ...state,
                    cumplimiento: 0,
                    porcentaje: 0,
                    incentivo: 0,
                };
                setState(resetState);
                if (setTotal) setTotal(0);
            }
        }
    }, [state.meta, state.real, porc_Incentivo]);


    return (
        <div className="simulador-incentivo-vendedor-input">
            <div className="input-container-one">
                <div className="input-section">
                    <div className="input-title-label">Venta total con tu PIN</div>
                    <SimuladorNumericInput
                        name="real"
                        label=""
                        value={state.real}
                        disabled={false}
                        onChange={handleChange}
                    />
                </div>
            </div>

            <div className="input-container-one">
                <div className="input-section">
                    <div className="input-title-label-incentive">Tu incentivo es de:</div>
                    <SimuladorNumericInput
                        name="incentivo"
                        label=""
                        value={state.incentivo}
                        disabled={true}
                        icono="pesos"
                        inputTotal="si"
                    />
                </div>
            </div>
        </div >
    );
};
